export interface ErrorHandlerOptions {
  /**
   * Application name for the purpose of logging
   * @default 'PORTAL'
   */
  appName: string;
  /**
   * @default 'Portal web'
   */
  loggerName?: string;
}
